<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                  <c-form-item type="input" label="活动标题" name="title"></c-form-item>
                  <c-form-item type="checkbox" label="活动状态" name="state" :options="activityState"></c-form-item>
                </c-form>
            </m-search>

            <m-operate>
                <c-button power="b_offline_activity_edit" color="sys" @click="navigateTo('/offline_activity_add')">新建活动</c-button>
            </m-operate>

            <c-table ref="table">
                <c-table-column
                        label="状态"
                        name="state"
                        width="60"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state == 1" style="color:darkgreen">启用</span>
                        <span v-if="data.state == 2" style="color:red">禁用</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="活动标题"
                        name="title"
                        width="200"
                ></c-table-column>

              <c-table-column
                  label="封面图"
                  name="presell_type"
                  width="80"
              >
                  <template v-slot="{data}">
                      <c-image :src="data.cover_image" preview size="30" style="margin-right: 10px;"></c-image>
                  </template>
              </c-table-column>

              <c-table-column
                  label="报名截止时间"
                  name="apply_deadline"
                  width="150"
              >
              </c-table-column>

              <c-table-column
                        type="sort"
                        label="排序"
                        name="sort_id"
                        power="b_offline_activity_edit"
                        @sort="sortHandle"
              >
              </c-table-column>

              <c-table-column
                  label="报名人数上限"
                  name="user_count"
              ></c-table-column>

              <c-table-column
                        label="已报名人数"
                        name="record_count"
              >
                  <template v-slot="{data}">
                      <a v-if="data.record_count > 0" style="color: blue"   @click="navigateTo(`/offline_activity_apply/${data.id}`)">
                          &nbsp;&nbsp;{{data.record_count}}&nbsp;&nbsp;
                      </a>
                      <span v-else style="color: darkgray">&nbsp;&nbsp;0&nbsp;&nbsp;</span>
                  </template>
              </c-table-column>


              <c-table-column
                    label="创建人"
                    name="create_user_realname"
                    width="150"
              >
              </c-table-column>

              <c-table-column
                    label="创建时间"
                    name="create_date"
                    width="145"
                >
              </c-table-column>
              <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="160"
              >
                    <template v-slot="row">
                        <c-table-button power="b_offline_activity_view" @click="navigateTo(`/offline_activity_detail/${row.data.id}`)">查看</c-table-button>
                        <c-table-button power="b_offline_activity_view" @click="navigateTo(`/offline_activity_apply/${row.data.id}`)">报名记录</c-table-button>
                        <c-table-button power="b_offline_activity_edit" v-if="row.data.state == 2"  @click="navigateTo(`/offline_activity_edit/${row.data.id}`)">修改</c-table-button>
                        <c-table-button power="b_offline_activity_edit" v-if="row.data.state == 2" @click="disableActivity(row.data,1)">启用</c-table-button>
                        <c-table-button power="b_offline_activity_edit" v-if="row.data.state == 1" @click="disableActivity(row.data,2)">禁用</c-table-button>
                        <c-table-button v-if="row.data.state == 2" power="b_offline_activity_edit" @click="deleteActivity(row.data)">删除</c-table-button>
                    </template>
              </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>

    export default {
        name: 'm_offline_activity',
        components: {},

        data() {
            return {
                activityState: [
                    {name: '启用',value: 1},
                    {name: '禁用',value: 2}
                ],
                activityType: [
                    {name: '定金',value: 1},
                    {name: '全款',value: 2}
                ]
            }
        },
        computed: {
            activityStateText() {
                var state = {};
                this.activityState.forEach(item => {
                    state[item.value] = item.name;
                });

                return state;
            }
        },

        mounted() {
            this.$refs.search.search();
            this.$bus.$on('offineActivityList.update', () => {
                this.$refs.search.search();
            });
        },

        methods: {
            searchHandle(data) {
                this.$refs.table.load({
                    url: '/offineActivity/list',
                    data
                });
            },

            disableActivity(item,state) {
                var message = (state == 2 ? '是否确定禁用活动' : '是否确定启用活动') + ('【'+item.title+'】？');
                this.$confirm({
                    text:message,
                    resolve: () => {
                        this.request({
                            url: '/offineActivity/updateState',
                            data: {
                                id: item.id,
                                state: state
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: state == 2 ? '禁用成功' :'启用成功'
                                });
                                this.$refs.table.update();
                            },
                            fail: (code, data, msg) => {
                                this.$confirm({
                                    text: msg,  // 提示内容,
                                    buttonName: '知道了',  // 确定按钮文字
                                    cancelButton: false  // 是否显示取消按钮
                                });
                                return false;
                            }
                        });
                    }
                });
            },

            deleteActivity(item) {
                var message = '是否确定删除活动【'+item.title+'】？';
                this.$confirm({
                    text: message,
                    resolve: () => {
                        this.request({
                            url: '/offineActivity/delete',
                            data: {
                                id: item.id
                            },
                            loading: true,
                            success: () => {
                                this.$message({
                                    text: '删除成功'
                                });
                                this.$refs.table.update();
                            }
                        });
                    }
                });
            },

            sortHandle(row, type, next) {
                //row.prev() 上一行数据
                //row.next() 下一行数据
                let submitData = {};
                if (type == 'top' || type == 'bottom') {
                    submitData.type = type;
                    submitData.id = row.data.id;
                }
                if (type == 'up') {
                    submitData.id1 = row.data.id;
                    submitData.id2 = row.prev().data.id;
                }
                if (type == 'down') {
                    submitData.id1 = row.data.id;
                    submitData.id2 = row.next().data.id;
                }
                this.request({
                    url: '/offineActivity/sort',
                    data: submitData,
                    loading: true,
                    success: data => {
                        if (type == 'top' || type == 'bottom') {
                            this.$refs.table.update();
                        } else {
                            next();
                        }
                    }
                });
            }
        }
    }
</script>